import type { Ctx } from '@/core/context';
import { bus } from '@/core/bus';
import { gainPoints, gainXp, levelOf } from './progress';
import { tr } from '@/i18n';

/** 成就：計數器（counters）、旗標（flags）、結局（endings）三種條件。 */
const derived = (ctx: Ctx): Record<string, number> => ({
  hazardsSeen: ctx.profile.hazardsSeen.length,
  productsSeen: ctx.profile.productsSeen.length,
  cadresTalked: ctx.profile.cadresTalked.length,
  deptsPlayed: ctx.profile.deptsPlayed.length,
  floorsToday: ctx.day?.floorsVisited.length ?? 0,
  recipesCollected: (ctx.profile.recipes ?? []).length,
  recipesAll: ctx.c?.menu && (ctx.profile.recipes ?? []).length >= ctx.c.menu.length ? 1 : 0,
  tipsHeardN: (ctx.profile.tipsHeard ?? []).length,
  levelN: ctx.c?.game?.progression ? levelOf(ctx) : 1,
});

export function bump(ctx: Ctx, key: string, n = 1): void {
  ctx.profile.counters[key] = (ctx.profile.counters[key] ?? 0) + n;
  check(ctx);
}
export function setFlag(ctx: Ctx, key: string): void {
  if (ctx.profile.flags[key]) return;
  ctx.profile.flags[key] = true;
  check(ctx);
}

export function check(ctx: Ctx): void {
  const p = ctx.profile, d = derived(ctx);
  for (const a of ctx.c.achievements) {
    if (p.achievements[a.id]) continue;
    const cond = a.condition;
    let ok = false;
    if ('counter' in cond) ok = ((p.counters[cond.counter] ?? 0) + (d[cond.counter] ?? 0)) >= cond.gte;
    else if ('flag' in cond) ok = !!p.flags[cond.flag];
    else if ('ending' in cond) ok = p.endings.includes(cond.ending);
    if (!ok) continue;
    p.achievements[a.id] = ctx.day?.day ?? p.day;
    const ch = p.challenges.includes(a.id);
    bus.emit('sfx', 'item');
    ctx.ui?.toast(tr("🏆 成就解鎖：{0} {1}{2}", a.icon, a.name, ch ? tr("（今日挑戰達成！）") : ''));
    if (ch && ctx.day) ctx.day.factory.trust = Math.min(100, ctx.day.factory.trust + 5);
    if (ctx.c?.game?.progression) { gainXp(ctx, 'achievement'); gainPoints(ctx, 'achievement', tr("成就：{0}", a.name)); }
  }
}

/** 今日挑戰：從還沒解鎖的成就抽 3 個。用進度代碼讀檔時會重新抽（成就可能隨機刷新）。 */
export function rollChallenges(ctx: Ctx, rnd: () => number = Math.random): void {
  const pool = ctx.c.achievements.filter(a => !ctx.profile.achievements[a.id] && !('ending' in a.condition)).map(a => a.id);
  const pick: string[] = [];
  while (pick.length < 3 && pool.length) pick.push(pool.splice(Math.floor(rnd() * pool.length), 1)[0]);
  ctx.profile.challenges = pick;
}
